<template>
    <Modal @modal:dismiss="$emit('dismiss')">
        <h3 slot="header">{{ value.id ? 'Modifier' : 'Ajouter' }} un droit de validation</h3>

        <div slot="body">
            <div class="form-control">
                <label>
                    Groupe métier <b>(obligatoire)</b>
                    <CustomSelect
                        class="stretch"
                        required
                        placeholder="Sélectionnez un groupe métier"
                        :options="business"
                        v-model="value.business"
                    />
                </label>
            </div>
            <div class="form-control">
                <label>
                    Groupe d'objets <b>(obligatoire)</b>
                    <CustomSelect
                        class="stretch"
                        required
                        placeholder="Sélectionnez un groupe d'objets"
                        :options="objects"
                        v-model="value.object"
                    />
                </label>
            </div>
            <div class="form-control">
                <label>
                    Valider les objets dont n'importe quel attribut a été modifié&nbsp;
                    <CustomCheckbox
                        class="stretch"
                        v-model="value.r_verif_all_tags"
                    ></CustomCheckbox>
                </label>
            </div>
            <div class="form-control" v-if="value.r_verif_all_tags !== true">
                <label>
                    <b>OU</b> valider les objets dont les attributs suivants ont été modifiés :
                    <CustomSelectTag
                        class="stretch"
                        placeholder="Sélectionnez un ou plusieurs attributs à valider"
                        :options="keys"
                        :multiple="true"
                        v-model="value.keys"
                    />
                </label>
            </div>
            <div class="form-control">
                <label>
                    <b>ET</b> valider les objets dont la géométrie a changé&nbsp;
                    <CustomCheckbox class="stretch" v-model="value.r_verif_geom"></CustomCheckbox>
                    <br />(indépendamment des attributs ci-dessus)
                </label>
            </div>
        </div>

        <div slot="footer">
            <div class="form-control form-inline">
                <CustomButton class="stretch" @click="$emit('dismiss')">Annuler</CustomButton>
                <CustomButton class="default stretch" @click="$emit('close')">
                    Enregistrer
                </CustomButton>
            </div>
        </div>
    </Modal>
</template>

<script>
import Modal from './../Modal';
import CustomButton from './../Button';
import CustomSelect from './../Select';
import CustomSelectTag from './../SelectTag';
import CustomCheckbox from './../Checkbox';

export default {
    props: ['value', 'business', 'objects', 'keys'],
    components: {
        Modal,
        CustomButton,
        CustomSelect,
        CustomSelectTag,
        CustomCheckbox,
    },
};
</script>

<style lang="scss"></style>
